'use client';

import { Tabs } from '@mantine/core';
import { useParams, usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import classes from './HeaderTabs.module.css';

interface TabProps {
  icon: any;
  label: string;
  link: string;
  value: string;
}

interface HeaderTabsProps {
  tabs: TabProps[];
}

export default function HeaderTabs({ tabs }: HeaderTabsProps) {
  const pathname = usePathname();
  const params = useParams();
  const [active, setActive] = useState('');
  const router = useRouter();

  useEffect(() => {
    tabs.forEach((tab) => {
      if (pathname.includes(tab.link)) setActive(tab.value);
    });

    return () => {
      setActive('');
    };
  }, [tabs, pathname, params]);

  return (
    <Tabs
      mt='sm'
      variant='outline'
      defaultValue='profile'
      value={active as string}
      onChange={(value) =>
        router.push(tabs.filter((tab) => tab.value === value)[0].link)
      }
      classNames={classes}
    >
      <Tabs.List justify='center'>
        {tabs.map((tab) => (
          <Tabs.Tab value={tab.value} key={tab.value} leftSection={tab.icon}>
            {tab.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  );
}
